const yearKey = (year) => (year === null || year === undefined ? '' : String(year));

const spellKey = (row, idField) => [row[idField], yearKey(row.start_year), yearKey(row.end_year)].join('|');

// An accepted match adds its rows to the contact's instead of replacing them. Rows the save clears
// on adoption lose their id so it recreates them; rows that stay on the same record (keepIds) keep
// it. Of two duplicates the persisted one wins, and a second persisted one is
// destroyed rather than left behind unposted.
export const mergeImportedRows = (currentRows, importedRows, idField, {keepIds = false} = {}) => {
    const current = (currentRows || [])
        .filter((row) => keepIds || !row._destroy)
        .map((row) => (keepIds ? row : {...row, id: null}));
    const merged = [];
    const indexByKey = new Map();

    [...current, ...(importedRows || [])].forEach((row) => {
        if (row._destroy || !row[idField]) {
            merged.push(row);
            return;
        }

        const key = spellKey(row, idField);
        if (!indexByKey.has(key)) {
            indexByKey.set(key, merged.length);
            merged.push(row);
        } else if (row.id && !merged[indexByKey.get(key)].id) {
            merged[indexByKey.get(key)] = row;
        } else if (row.id) {
            merged.push({...row, _destroy: true});
        }
    });

    return merged;
};

export const mergeById = (currentItems, importedItems) => {
    const seen = new Set();

    return [...(currentItems || []), ...(importedItems || [])].filter((item) => {
        const key = String(item.id);
        if (seen.has(key)) return false;

        seen.add(key);
        return true;
    });
};
